import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Search from "./Search";
import korea from "../../assets/icon/korea.svg"
import japan from "../../assets/icon/japan.svg"
import taiwan from "../../assets/icon/taiwan.svg"
import usa from "../../assets/icon/usa.png";
import download from "../../assets/icon/download.svg"; // 추가
import commu from "../../assets/icon/commu.svg"
import about from "../../assets/icon/about.svg"
import my from "../../assets/icon/my.svg"
import cart from "../../assets/icon/cart.svg"
import kakao from "../../assets/icon/kakao.svg"
import insta from "../../assets/icon/insta.svg"
import youtube from "../../assets/icon/youtube.svg"
import useUserStore from '../../store/userStore';
import PopupLoginError from '../Popup/LoginError';
import { useLanguage } from "../../hooks/useLanguage";

function MobileHam({ isOpen, onClose, categoryList }) {
  const { t } = useLanguage();
  const { currentLanguage, changeLanguage} = useLanguage();
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const navigate = useNavigate();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { memberTokens, logout } = useUserStore();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isPopupLoginError, setIsPopupLoginError] = useState(false);
  const [loginMessage, setLoginMessage] = useState("");
  const [showLoginMessage, setShowLoginMessage] = useState(false);
  const [showLangMenu, setShowLangMenu] = useState(false); // 다국어 선택 드롭
  const [showFlagMenu, setShowFlagMenu] = useState(false); // 해외 국기 메뉴 드롭
  const [showAppMenu, setShowAppMenu] = useState(false); // APP 다운로드 메뉴 드롭 추가
  const flagMenuRef = useRef(null);
  const langMenuRef = useRef(null);
  const appMenuRef = useRef(null); // APP 메뉴 ref 추가

  // 국가/지역 선택을 위한 별도 상태 추가
  const [selectedCountry, setSelectedCountry] = useState('ko'); // 기본값을 한국으로 설정


  useEffect(() => {
    setIsLoggedIn(!!memberTokens);
  }, [memberTokens]);

  // 메인 카테고리 클릭
  const handleMainMenuClick = (category) => {
    if (category.category2 && category.category2.length > 0) {
      setActiveSubmenu(activeSubmenu === category.category_seq ? null : category.category_seq);
    } else {
      // 서브카테고리 없는 경우 바로 이동
      navigate(`/category/cinemaPage?title=${encodeURIComponent(category.category_name)}&category_code=${category.category_code}`);
      onClose();
    }
  };

  // 서브 카테고리 클릭
  const handleSubMenuClick = ( subCategory ) => {
    navigate(`/category/cinemaPage?title=${encodeURIComponent(subCategory.category_name)}&category_code=${subCategory.category_code}`);
    onClose();
  };

  // 로그인 필요한 기능 접근 처리
  const handleAuthRequired = (e, path) => {
    e.preventDefault();

    // 로그인 체크
    if (!memberTokens) {
      setIsPopupLoginError({
        message: t('login_required'),
        action: 'navigate_login'
      });
      return;
    }

    navigate(path);
    onClose();
  };

  const handleConfirm = () => {
    navigate('/login');
    onClose();
  };

  // 로그인/로그아웃 처리 함수
  const handleAuthAction = () => {
    if (isLoggedIn) {
      // 로그아웃 처리
      logout();
      setLoginMessage("로그아웃이 완료되었습니다.");
      setShowLoginMessage(true);

      // 메시지 표시 후 일정 시간 후 숨김
      setTimeout(() => {
        setShowLoginMessage(false);
        navigate('/');
        onClose();
      }, 1500);
    } else {
      // 로그인 페이지로 이동
      navigate('/login');
      onClose();
    }
  };

  // 검색팝업
  const handleSearchOpen =()=>{
    setIsSearchOpen(true);
  };
  const handleSearchClose =()=>{
    setIsSearchOpen(false);
  };

  // 다국어, 국기 드롭박스 닫히게
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        langMenuRef.current && !langMenuRef.current.contains(event.target)
      ) {
        setShowLangMenu(false);
      }
      if (flagMenuRef.current && !flagMenuRef.current.contains(event.target)) {
        setShowFlagMenu(false);
      }
      if (appMenuRef.current && !appMenuRef.current.contains(event.target)) {
        setShowAppMenu(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // 언어 변경 핸들러 추가
  const handleLanguageChange = (language) => {
    changeLanguage(language);
  };

  // 외부 클릭 시 창 닫기 핸들러 수정
  const handleOutsideClick = (e) => {
    // 클릭된 요소가 button이나 그 자식 요소가 아닌 경우에만 창 닫기
    if (!e.target.closest('button') && !e.target.closest('div[style*="width: 50%"]')) {
      onClose();
    }
  };

  // React Native 환경 감지 함수 추가
  const isReactNativeApp = () => {
    return window.ReactNativeWebView ||
           navigator.userAgent.includes('ReactNative') ||
           window.navigator.userAgent.includes('wv'); // WebView 감지
  };


    return (
        <aside className={`layout_side ${isOpen ? 'open' : ''}`}>
            <div className="mo_dimmed" onClick={onClose}></div>
            <div className="side_inner">
              {/* side_top */}
              <div className="side_top" style={{padding:'18px 16px'}}>

                <div className='flex-center gap_8'>
                  {/* 다국어 */}
                  <div className="lang_dropdown" ref={langMenuRef}>
                    <div className="current_lang" onClick={() => setShowLangMenu(!showLangMenu)}>
                      {currentLanguage === 'ko' ? 'KOR' :
                      currentLanguage === 'ja' ? 'JPN' :
                      currentLanguage === 'zh' ? 'TWN' : 'ENG'}
                    </div>
                    {showLangMenu && (
                      <ul className="dropdown">
                          <li onClick={() => { handleLanguageChange('ko'); setShowLangMenu(false); }}>KOR</li>
                          <li onClick={() => { handleLanguageChange('ja'); setShowLangMenu(false); }}>JPN</li>
                          <li onClick={() => { handleLanguageChange('zh'); setShowLangMenu(false); }}>TWN</li>
                          <li onClick={() => { handleLanguageChange('en'); setShowLangMenu(false); }}>ENG</li>
                      </ul>
                    )}
                  </div>

                  {/* 해외 사이트 이동 */}
                  <div className="lang_dropdown" ref={flagMenuRef}>
                    <div className="current_lang" onClick={() => setShowFlagMenu(!showFlagMenu)}>
                      <img src={
                        selectedCountry === 'ko' ? korea :
                        selectedCountry === 'ja' ? japan :
                        selectedCountry === 'zh' ? taiwan :
                        usa
                      } alt="country" />
                    </div>
                    {showFlagMenu && (
                      <ul className="dropdown">
                        <li onClick={() => {
                          setSelectedCountry('ko');
                          setShowFlagMenu(false);
                          window.open('https://www.daypay.kr', '_blank');
                        }}>
                          <img src={korea} alt="Korean" />
                        </li>
                        <li onClick={() => {
                          setSelectedCountry('ja');
                          setShowFlagMenu(false);
                          window.open('https://www.daypay.jp', '_blank');
                        }}>
                          <img src={japan} alt="Japanese" />
                        </li>
                        <li onClick={() => {
                          setSelectedCountry('zh');
                          setShowFlagMenu(false);
                          window.open('https://www.daypay.tw', '_blank');
                        }}>
                          <img src={taiwan} alt="Traditional Chinese" />
                        </li>
                        {/* <li onClick={() => {
                          setSelectedCountry('en');
                          setShowFlagMenu(false);
                          window.location.href = '/';
                        }}>
                          <img src={usa} alt="English" />
                        </li> */}
                      </ul>
                    )}
                  </div>
                </div>
                <div className='flex-center gap_16'>
                  {/* React Native 앱에서는 APP 다운로드 메뉴 숨기기 */}
                  {!isReactNativeApp() && (
                    <div className="app_dropdown" ref={appMenuRef}>
                      <div className="current_lang" onClick={() => setShowAppMenu(!showAppMenu)} style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                        <img src={download} alt="APP 다운로드" style={{width: '16px', height: '16px'}} />
                        <span style={{fontSize: '12px', fontWeight: '400'}}>APP 다운로드</span>
                      </div>
                      {showAppMenu && (
                        <ul className="dropdown">
                          <li
                            onClick={() => {
                              window.open('https://play.google.com/store/apps/details?id=com.daypay.app', '_blank');
                              setShowAppMenu(false);
                            }}
                          >
                            Android
                          </li>
                          <li
                            onClick={() => {
                              window.open('https://apps.apple.com/app/daypay/id123456789', '_blank');
                              setShowAppMenu(false);
                            }}
                          >
                            iOS
                          </li>
                        </ul>
                      )}
                    </div>
                  )}
                </div>

                <div className='flex-center gap_8'>
                  <button
                      className="black_srch"
                      type="button"
                      onClick={handleSearchOpen}
                  />
                  <button
                      className="close_btn"
                      type="button"
                      onClick={onClose}
                  />
                </div>
              </div>

        <div className="side_mid">
          <div className="user_btn flex-center-4">
            <button
              className="tab_btn white"
              onClick={handleAuthAction}
            >
              {isLoggedIn ? 'LOGOUT' : 'LOGIN'}
            </button>

            {!isLoggedIn && (
              <Link
                className="tab_btn black"
                to="/joinAgreement"
                onClick={onClose}
              >
                JOIN
              </Link>
            )}
          </div>

          <ul className="ctg_list main_ctg">
            {/* 기존 코드 - Purpose 카테고리 포함
            {categoryList && categoryList.map((category) => (
              <li key={category.category_seq} className="ctg_item">
                <button
                  type="button"
                  className={`ctg_name ${activeSubmenu === category.category_seq ? 'active' : ''}`}
                  onClick={() => handleMainMenuClick(category)}
                >
                  {category.category_name}
                </button>
                {category.category2 && activeSubmenu === category.category_seq && (
                  <div className='sub_menu'>
                    <ul className="sub_list">
                      {category.category2.map((sub) => (
                        <li key={sub.category_seq}>
                          <button
                            type="button"
                            onClick={() => handleSubMenuClick(category, sub)}
                            style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
                          >
                            {sub.category_name}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            ))}
            */}

            {/* 새로운 코드 - Purpose 카테고리 제외 */}
            {categoryList && categoryList
              .filter(category => category.category_name !== 'BRAND') // BRAND 카테고리 제외
              .map((category) => (
              <li key={category.category_seq} className="ctg_item" onClick={handleOutsideClick}>
                <button
                  type="button"
                  className={`ctg_name ${activeSubmenu === category.category_seq ? 'active' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation(); // 이벤트 버블링 방지
                    handleMainMenuClick(category);
                  }}
                  style={{width: '50%'}}
                >
                  {category.category_name}
                </button>
                {category.category2 && activeSubmenu === category.category_seq && (
                  <div className='sub_menu' onClick={handleOutsideClick}>
                    <ul className="sub_list">
                      {category.category2.map((sub) => (
                        <li key={sub.category_seq}>
                          <div onClick={(e) => {
                            e.stopPropagation(); // 이벤트 버블링 방지
                            handleSubMenuClick(category, sub);
                          }}
                            >
                            <button
                              type="button"
                              style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer', display: 'flex', gap: '4px' }}
                            >
                              <span style={{ color: '#BBB' }}>• </span>{sub.category_name}
                            </button>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            ))}
          </ul>

          <div className="btm_menu">
            <Link to='/community'
              className="btm_item"
              onClick={onClose}
            >
              <span><img src={commu} alt="commu"/></span>
              <span>Community</span>
            </Link>
            <Link to='/about'
              className="btm_item"
              onClick={onClose}
            >
              <span><img src={about} alt="about"/></span>
              <span>About us</span>
            </Link>

            <Link
              className="btm_item"
              onClick={(e) => handleAuthRequired(e, '/myPage')}
            >
              <span><img src={my} alt="my"/></span>
              <span>Mypage</span>
            </Link>
            <Link
              className="btm_item"
              onClick={(e) => handleAuthRequired(e, '/order')}
            >
              <span><img src={cart} alt="cart"/></span>
              <span>Cart</span>
            </Link>
          </div>

          <div className="btm_sns">
            <Link to='/kakao' onClick={onClose}>
              <span><img src={kakao} alt="kakao"/></span>
            </Link>
            <Link to='/insta' onClick={onClose}>
              <span><img src={insta} alt="insta"/></span>
            </Link>
            <Link to="/youtube" onClick={onClose}>
              <span><img src={youtube} alt="youtube"/></span>
            </Link>
          </div>
        </div>
      </div>



      {/*검색 */}
      <Search
        isOpen={isSearchOpen}
        onClose={handleSearchClose}
      />


      {showLoginMessage && (
        <div className="login-message-popup">
          <div className="message-content">
            {loginMessage}
          </div>
        </div>
      )}

      <PopupLoginError
        isPopup={isPopupLoginError}
        setIsPopup={setIsPopupLoginError}
        onConfirm={handleConfirm}
      />

      <style jsx="true">{`
        .login-message-popup {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-color: rgba(0, 0, 0, 0.7);
          color: white;
          padding: 15px 25px;
          border-radius: 5px;
          z-index: 9999;
          animation: fadeIn 0.3s, fadeOut 0.3s 1.2s;
        }
        
        .message-content {
          font-size: 16px;
          text-align: center;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes fadeOut {
          from { opacity: 1; }
          to { opacity: 0; }
        }
      `}</style>
    </aside>
  );
}

export default MobileHam;
